import { useState } from "react";
import { ExportButton } from "features/brm";
import { ExportTableModal, useExportTable } from "features/exporter";
// Hooks
import { useModal } from "hooks";
// Styles
import Title from "components/elements/StyledTitle";
import ContentLayout from "brm/layout/Content/ContentLayout";
import Buttons from "components/elements/TableButtonsDivStyled";

// Local
import ThreatEventTable from "./tables/ThreatEventTable";

function ThreatEvent() {
  const [, setSelectedRows] = useState([]);
  const [refresh, setRefresh] = useState(true);
  const { disableExport, setExportTableData, handleTableExport } = useExportTable();
  const { isVisible, toggle } = useModal();

  const trevHeader = (
    <Title id="ThreatEvent_title">
      Threat Events
      <Buttons id="ThreatEvent_buttons">
        <ExportButton onClick={() => toggle()} disableExport={disableExport} />
      </Buttons>
    </Title>
  );

  const trevMain = (
    <>
      <ExportTableModal onTableExport={handleTableExport} isVisible={isVisible} toggle={toggle} />
      <ThreatEventTable
        setSelectedRows={setSelectedRows}
        refresh={refresh}
        setRefresh={setRefresh}
        setExportTableData={setExportTableData}
      />
    </>
  );

  return <ContentLayout pageId="ThreatEvent_page" header={trevHeader} main={trevMain} />;
}

export default ThreatEvent;
